<template>
  <div>
    <el-col :span="10" style="padding: 30px;">
      <el-card class="box-card">
        <div slot="header" style="height: 40px; display: flex; align-items: center;">
          <span>活动信息</span>
        </div>
        <div style="padding: 10px;">
          <el-form label-width="120px" label-position="left">
            <el-form-item label="活动名称:" >
              <el-input v-model="taskname" placeholder="请输入促销活动名称"></el-input>
            </el-form-item>
            <el-form-item label="活动日期:">
              <el-date-picker
                v-model="taskdate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form label-width="120px" label-position="left">
              <el-form-item label="活动简介:" >
                <el-input v-model="taskdes" placeholder="请输入活动简介"></el-input>
              </el-form-item>
            </el-form>
          </el-form>
          <div>
            <el-button style="float: right;" @click="hdfabu">活动发布</el-button>
          </div>
          <div style="margin-top: 40px; margin-left: 5px; color: darkred;">
            *请先添加活动，然后再配置促销内容
          </div>
        </div>
      </el-card>
    </el-col>
    <el-col :span="14" style="padding: 30px;">
      <el-table
        stripe
        :header-cell-style="{'text-align':'center'}"
        :data="taskdata"
        ref="multipleTable">
        <el-table-column
          prop="id"
          label="活动编号"
        >
        </el-table-column>
        <el-table-column
          prop="taskname"
          label="活动名称">
        </el-table-column>
        <el-table-column
          prop="starttime"
          label="开始时间">
        </el-table-column>
        <el-table-column
          prop="endtime"
          label="开始时间">
        </el-table-column>
        <el-table-column
          label="操作"
          width="120px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查看促销内容" placement="top-start">
              <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="seetask(scope.$index, taskdata)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="编辑促销内容" placement="top-start">
              <i class="fa fa-pencil-square-o ciicon curpointer" v-on:click="edittask(scope.$index, taskdata)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="取消该活动" placement="top-start">
              <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="removetask(scope.$index, taskdata)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <el-dialog title="编辑促销方案" :visible.sync="cxpanelvisible">
      <el-row class="querypanel">
        <el-col :span="10">
          <el-row>
            <el-col :span="24">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="请输入商品名称" >
                  <el-input v-model="qgoodsname" placeholder="请输入内容">
                    <el-button @click="querygoods" slot="append" icon="el-icon-search"></el-button>
                  </el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="24">
              <el-table
                stripe
                :header-cell-style="{'text-align':'center'}"
                :data="goodsdata"
                ref="cxgoodstb">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="商品名称">
                </el-table-column>
                <el-table-column
                  prop="barcode"
                  label="客户条码">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="14">
          <div class="rightpanel">
            <el-collapse v-model="cxactive" accordion @change="cxwaychange">
              <el-collapse-item title="满减促销" name="0">
                <el-table
                  stripe
                  :header-cell-style="{'text-align':'center'}"
                  :data="mjcxdata"
                  ref="selmjtb">
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    prop="full_price"
                    label="满额金额">
                  </el-table-column>
                  <el-table-column
                    prop="minus_price"
                    label="减额金额">
                  </el-table-column>
                </el-table>
              </el-collapse-item>
              <el-collapse-item title="满赠促销" name="1">
                <el-table
                  stripe
                  :header-cell-style="{'text-align':'center'}"
                  :data="cxmzdata"
                  ref="selmztb">
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    prop="fullprice"
                    label="满额金额">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="赠品名称">
                  </el-table-column>
                  <el-table-column
                    prop="count"
                    label="赠品数量">
                  </el-table-column>
                </el-table>
              </el-collapse-item>
              <el-collapse-item title="限时减免" name="2">
                <el-table
                  stripe
                  :header-cell-style="{'text-align':'center'}"
                  :data="xscxdata"
                  ref="selxscx">
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    prop="cxrange"
                    label="限减金额">
                  </el-table-column>
                </el-table>
              </el-collapse-item>
              <el-collapse-item title="限时打折" name="3">
                <el-table
                  stripe
                  :header-cell-style="{'text-align':'center'}"
                  :data="xszkdata"
                  ref="selxsdz">
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    prop="cxpercent"
                    label="限时折扣">
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-col>
        <el-col :span="24">
          <el-button style="margin-top: 10px" @click="savecxfa">保存促销方案</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog title="当前促销方案" :visible.sync="subcxpanelvisible">
      <el-row class="querypanel">
        <el-table
          stripe
          :header-cell-style="{'text-align':'center'}"
          :data="subtaskdata"
          ref="multipleTable">
          <el-table-column
            prop="taskname"
            label="活动名称">
          </el-table-column>
          <el-table-column
            prop="name"
            label="促销商品">
          </el-table-column>
          <el-table-column
            prop="protype"
            label="促销类别">
            <template slot-scope="scope">
              <div v-if="scope.row.protype === 1">满减</div>
              <div v-if="scope.row.protype === 2">满赠</div>
              <div v-if="scope.row.protype === 3">限时直减</div>
              <div v-if="scope.row.protype === 4">限时打折</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="proid"
            label="促销ID">
          </el-table-column>
          <el-table-column
            prop="starttime"
            label="开始时间">
          </el-table-column>
          <el-table-column
            prop="endtime"
            label="结束时间">
          </el-table-column>
          <el-table-column
            label="操作"
            width="80px"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="查看促销内容" placement="top-start">
                <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="seesubtask(scope.$index, subtaskdata)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="移除该规则" placement="top-start">
                <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="removesubtaskgz(scope.$index, subtaskdata)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
  var that
  export default {
    name: 'SaleFB',
    data () {
      return {
        taskname: '',
        taskdate: '',
        taskdes: '',
        qgoodsname: '',
        cxpanelvisible: false,
        subcxpanelvisible: false,
        taskdata: [],
        cxmzdata: [],
        mjcxdata: [],
        khid: '',
        xscxdata: [],
        xszkdata: [],
        cxactive: '',
        goodsdata: [],
        subtaskdata: [],
        goodstype: '',
        goodstypelist: [],
        resultinfo: ''
      }
    },
    mounted () {
      that = this
      var v = getCookie('cusid')
      this.khid = v
      that.$options.methods.querycxorder()
      that.$options.methods.querymj()
      that.$options.methods.querygoodstype()
      that.$options.methods.querycxmz()
      that.$options.methods.queryxscx()
      that.$options.methods.queryxsdz()
    },
    methods: {
      querymjbyid (id) {
        var qstr = {
          whereinfo: " id='" + id + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryptfm',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.resultinfo = res.data[0]
              that.$notify.info({
                title: '满减活动',
                message: '满:' + that.resultinfo.full_price + ',减:' + that.resultinfo.minus_price
              });
            } else {
              that.resultinfo = ''
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querycxmzbyid (id) {
        var qstr = {
          whereinfo: " id='" + id + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryptgw',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('*****************初始化满赠数据******************')
            if (res.data.length > 0) {
              that.resultinfo = res.data[0]
              that.$notify.info({
                title: '满赠活动',
                message: '满' +that.resultinfo.full_price + '元后，赠送' + that.resultinfo.count + '件' + that.resultinfo.name
              });
            } else {
              that.resultinfo = ''
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      queryxscxbyid (id) {
        var qstr = {
          whereinfo: " id='" + id + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryptsd',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.resultinfo = res.data[0]
              that.$notify.info({
                title: '限时直减',
                message: '限定时间内直接减免' + that.resultinfo.cxrange + '元'
              });
            } else {
              that.resultinfo = ''
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      queryxsdzbyid (id) {
        var qstr = {
          whereinfo: " id='" + id + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryptdiscount',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.resultinfo = res.data[0]
              that.$notify.info({
                title: '限时打折',
                message: '限定时间内折扣' + that.resultinfo.cxpercent + '%'
              });
            } else {
              that.resultinfo = ''
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querymj () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryptfm',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.mjcxdata = res.data
            } else {
              that.mjcxdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querycxmz () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryptgw',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('*****************初始化满赠数据******************')
            if (res.data.length > 0) {
              console.log('读取到满赠数据')
              that.cxmzdata = res.data
            } else {
              that.cxmzdata = []
              console.log('获取满赠数据失败')
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      queryxscx () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryptsd',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.xscxdata = res.data
            } else {
              that.xscxdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      queryxsdz () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryptdiscount',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.xszkdata = res.data
            } else {
              that.xszkdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      quercxway () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querypttype',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.cxwaydata = res.data
            } else {
              that.cxwaydata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querygoods () {
        console.log('选择商品类别')
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "' and name like  '%" + that.qgoodsname + "%'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryginfo',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('*****************初始化分类数据******************')
            if (res.data.length > 0) {
              console.log('已完成分类数据初始化')
              that.goodsdata = res.data
            } else {
              that.goodsdata = []
              console.log('获取分类数据失败')
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querycxorder () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querypttask',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.taskdata = res.data
            } else {
              that.taskdata = []
            }
          })
          .catch(function (error) {
            window.console.log('error' + error)
          })
      },
      hdfabu () {
        window.console.log('活动发布')
        if (that.taskname !== '' || that.taskdate !== '') {
          var addtask = {
            id: '',
            taskname: that.taskname,
            starttime: that.taskdate[0] + ' 00:00:00',
            endtime: that.taskdate[1] + ' 00:00:00',
            taskdes: that.taskdes,
            ownphone: localStorage.getItem('phone'),
            cusid: that.khid.toString()
          }
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/addpttask',
            method: 'post',
            data: addtask,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.result === 'success') {
                that.$message({
                  type: 'success',
                  message: '促销活动添加完毕!'
                })
                that.$options.methods.querycxorder()
              }
            })
            .catch(function (error) {
              window.console.log('error' + error)
            })
        } else {
          this.$message('活动名称和时间必须填写');
        }
      },
      edittask (index, data) {
        window.console.log(data[index])
        that.selectcxmain = data[index]
        that.cxpanelvisible = true
      },
      removetask (index, data) {
        var selectdata = data[index]
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/delpttask',
          method: 'post',
          data: {
            id:  selectdata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.$options.methods.querycxorder()
            }
          })
          .catch(function (error) {
            window.console.log('error' + error)
          })
      },
      seetask (index, data) {
        window.console.log(data[index])
        this.subcxpanelvisible = true
        var qstr = {
          whereinfo: " taskid='" + data[index].id + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querypttaskcontext',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log('*****************初始化满赠数据******************')
            if (res.data.length > 0) {
              window.console.log('读取到活动数据')
              that.subtaskdata = res.data
            } else {
              that.subtaskdata = []
              window.console.log('获取活动数据失败')
            }
          })
          .catch(function (error) {
            window.console.log('error' + error)
          })
      },
      seesubtask (index,data) {
        var tmpdata = data[index]
        localStorage.setItem('taskid',tmpdata.proid)
        if (tmpdata.protype === 1) {
          that.querymjbyid(tmpdata.proid)
        }
        if (tmpdata.protype === 2) {
          that.querycxmzbyid(tmpdata.proid)
        }
        if (tmpdata.protype === 3) {
          that.queryxscxbyid(tmpdata.proid)
        }
        if (tmpdata.protype === 4) {
          that.queryxsdzbyid(tmpdata.proid)
        }
      },
      querysubtaskbyid () {
        var qstr = {
          whereinfo: ' taskid = ' + localStorage.getItem('taskid'),
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querypttaskcontext',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log('*****************初始化满赠数据******************')
            if (res.data.result === 'success') {
              window.console.log('读取到满赠数据')
              that.subtaskdata = res.data
            } else {
              that.subtaskdata = []
              window.console.log('获取满赠数据失败')
            }
          })
          .catch(function (error) {
            window.console.log('error' + error)
          })
      },
      querysubtask () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('phone') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querypttaskcontext',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log('*****************初始化满赠数据******************')
            if (res.data.result === 'success') {
              window.console.log('读取到满赠数据')
              that.subtaskdata = res.data
            } else {
              that.subtaskdata = []
              window.console.log('获取满赠数据失败')
            }
          })
          .catch(function (error) {
            window.console.log('error' + error)
          })
      },
      removesubtaskgz (index, data) {
        var selectdata = data[index]
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/delpttaskcontext',
          method: 'post',
          data: {
            id: selectdata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.querysubtaskbyid()
            }
          })
          .catch(function (error) {
            window.console.log('error' + error)
          })
      },
      savecxfa () {
        window.console.log('所选商品')
        window.console.log(that.selectcxmain)
        window.console.log(this.$refs.cxgoodstb.selection)
        window.console.log(this.$refs.selmjtb.selection)
        window.console.log(this.$refs.selmztb.selection)
        window.console.log(this.$refs.selxscx.selection)
        window.console.log(this.$refs.selxsdz.selection)
        window.console.log(that.selectcxmain.id.Int64)
        window.console.log(that.$refs.cxgoodstb.selection[0].id.Int64)
        window.console.log(that.$refs.selmjtb.selection[0].id.Int64)
        var idatas = []
        if (this.$refs.cxgoodstb.selection.length <= 0) {
          that.$message({
            type: 'info',
            message: '请先选择商品!'
          })
        } else {
          for (var index in this.$refs.cxgoodstb.selection) {
            var goodsinfotmp = this.$refs.cxgoodstb.selection[index]
            if (this.$refs.selmjtb.selection.length > 0) {
              for (var index1 in this.$refs.selmjtb.selection) {
                var cxtmp = this.$refs.selmjtb.selection[index1]
                var idata = {
                  taskid: that.selectcxmain.id.toString(),
                  goodsid: goodsinfotmp.id.toString(),
                  protype: cxtmp.typeid.toString(),
                  proid: cxtmp.id.toString(),
                  ownphone: localStorage.getItem('phone'),
                  cusid: that.khid.toString()
                }
                idatas.push(idata)
              }
            }
            if (this.$refs.selmztb.selection.length > 0) {
              for (var index2 in this.$refs.selmztb.selection) {
                var cxtmp1 = this.$refs.selmztb.selection[index2]
                var idata1 = {
                  taskid: that.selectcxmain.id.toString(),
                  goodsid: goodsinfotmp.id.toString(),
                  protype: cxtmp1.typeid.toString(),
                  proid: cxtmp1.id.toString(),
                  ownphone: localStorage.getItem('phone'),
                  cusid: that.khid.toString()
                }
                idatas.push(idata1)
              }
            }
            if (this.$refs.selxscx.selection.length > 0) {
              for (var index3 in this.$refs.selxscx.selection) {
                var cxtmp2 = this.$refs.selxscx.selection[index3]
                var idata2 = {
                  taskid: that.selectcxmain.id.toString(),
                  goodsid: goodsinfotmp.id.toString(),
                  protype: cxtmp2.typeid.toString(),
                  proid: cxtmp2.id.toString(),
                  ownphone: localStorage.getItem('phone'),
                  cusid: that.khid.toString()
                }
                idatas.push(idata2)
              }
            }
            if (this.$refs.selxsdz.selection.length > 0) {
              for (var index4 in this.$refs.selxsdz.selection) {
                var cxtmp3 = this.$refs.selxsdz.selection[index4]
                var idata3 = {
                  taskid: that.selectcxmain.id.toString(),
                  goodsid: goodsinfotmp.id.toString(),
                  protype: cxtmp3.typeid.toString(),
                  proid: cxtmp3.id.toString(),
                  ownphone: localStorage.getItem('phone'),
                  cusid: that.khid.toString()
                }
                idatas.push(idata3)
              }
            }
          }
        }
        window.console.log(idatas)
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/paddpttaskcontext',
          method: 'post',
          data: idatas,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '已保存促销方案'
              })
              that.cxpanelvisible = false
            }
          })
          .catch(function (error) {
            window.console.log('error' + error)
          })
      },
      cxwaychange (val) {
        window.console.log(val)
        that.cxactive = val
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/control/SaleFB.vue